import React, { useEffect, useState } from 'react'
import { Input } from '../ui/input'
import PhoneInput from 'react-phone-input-2'
import { Button } from '../ui/button'
import { getCurrentCountryCode } from '../../utils/get-current-country-code';
import { useMutation } from '@apollo/client';
import { isMobile } from 'react-device-detect';
import { CREATE_CUSTOMER } from '../../apollo-client/graphql/customer/customer.mutation';
import { useToast } from '../ui/use-toast';
import { cn } from '../../lib/utils';

const LeadForm = ({ isShowLeadForm, setIsShowLeadForm, leadConfig, businessId, leadFormHeight, updateCustomerId }) => {

  const { toast } = useToast()

  const [countryCode, setCountryCode] = useState("");
  const [phoneNumberExpectedLength, setPhoneNumberExpectedLength] = useState(0);
  const [formValue, setFormValue] = useState({
    name: "",
    email: "",
    phoneNo: ""
  });

  const [createCustomer, { loading }] = useMutation(CREATE_CUSTOMER);

  // GET COUNTRY CODE
  useEffect(() => {
    (async () => {
      const code = await getCurrentCountryCode();
      setCountryCode(code);
    })()
  }, [])

  const handleInputChange = (e) => setFormValue({ ...formValue, [e?.target?.name]: e?.target?.value })

  const handleSave = async (e) => {
    e?.preventDefault();
    if ((leadConfig?.name?.isEnable && !formValue.name) || (leadConfig?.email?.isEnable && !formValue.email) || (leadConfig?.phone && !formValue.phoneNo)) {
      toast({ description: "Please fill up all details", variant: "destructive" });
    } else if (leadConfig?.phone && phoneNumberExpectedLength > formValue.phoneNo?.length) {
      toast({ description: "Phone number is not valid", variant: "destructive" });
    } else {
      try {
        const res = await createCustomer({
          variables: {
            input: {
              ...formValue,
              company: businessId
            }
          }
        })
        setFormValue(null);
        setIsShowLeadForm(!isShowLeadForm);
        await updateCustomerId(res?.data?.createCustomerForChatbot?._id);
      } catch (err) {
        toast({ description: err?.message, variant: "destructive" });
        console.error('Error during create customer:', err);
      }
    }
  }
  const handleCancel = () => {
    setFormValue(null);
    setIsShowLeadForm(!isShowLeadForm);
  }
  return (
    <div className={cn('p-4 bg-white rounded-t-md rounded-b-lg overflow-y-auto overflow-x-hidden', isMobile && "rounded-b-none")} style={{ height: leadFormHeight ? leadFormHeight : '65vh' }}>
      <form>
        <span className="mb-4 text-lg font-semibold flex justify-center ">{leadConfig?.title}</span>
        {leadConfig?.name?.isEnable &&
          <div className="mb-[1.2rem]">
            <label className="text-sm font-medium block mb-[5px]" htmlFor="">
              Name
            </label>
            <Input
              fullWidth
              id="name"
              label="name"
              sx={{ mb: 4 }}
              placeholder={leadConfig?.name?.text || "Enter you name"}
              name="name"
              value={formValue?.name}
              onChange={handleInputChange}
            />
          </div>
        }
        {leadConfig?.email?.isEnable &&
          <div className="mb-[1.2rem]">
            <label className="text-sm font-medium block mb-[5px]" htmlFor="">
              Email
            </label>
            <Input
              fullWidth
              id="email"
              label="email"
              sx={{ mb: 4 }}
              placeholder={leadConfig?.email?.text || "Enter you email"}
              name="email"
              value={formValue?.email}
              onChange={handleInputChange}
            />
          </div>
        }
        {leadConfig?.phone &&
          <div className="mb-[1.2rem]">
            <label className="text-sm font-medium block mb-[5px]" htmlFor="">
              Phone No.
            </label>
            <PhoneInput
              className="border border-input flex h-9 w-full rounded-md bg-transparent pr-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm font-medium file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
              inputStyle={{
                padding: "0px auto",
                marginLeft: 0,
                background: "transparent",
                border: "none",
                borderRadius: "0px",
                lineHeight: "1px",
                height: "100%",
                width: "100%",
                outline: "none",
                boxShadow: "none",
              }}
              isValid={(value, country) => {
                setPhoneNumberExpectedLength(country?.format?.split('').filter((char) => char === ".").length)
                return true;
              }}
              enableSearch
              placeholder="Enter your phone number"
              country={countryCode?.toLocaleLowerCase()}
              name="phoneNo"
              value={formValue?.phoneNo}
              onChange={(value) => handleInputChange({ target: { name: "phoneNo", value } })}
            />
          </div>
        }
        <div className='flex justify-end items-center'>
          <Button disabled={loading} onClick={handleCancel} type="button" variant="secondary" className="mr-2">Cancel</Button>
          <Button disabled={loading || (!leadConfig?.name?.isEnable && !leadConfig?.email?.isEnable && !leadConfig?.phone)} onClick={(e) => handleSave(e)} type="submit" variant="default">Save</Button>
        </div>
      </form>
    </div>
  )
}

export default LeadForm